import { Interval, PlanCard } from './Plan'
import React, { useState } from 'react'
import { Switch } from '../ui/switch'
import classNames from 'classnames'
import { ConfirmationDrawer } from './ConfirmationDrawer'
import { BillingPlan, PremiumPlanV1, StandardPlanV1 } from './plans'
import { useUser } from '../../hooks/useUser'

export const SalesBasedBilling = () => {
    const [interval, setInterval] = useState(Interval.Yearly)
    const [selectedPlan, setSelectedPlan] = useState<null | BillingPlan>(null)
    const { activeSubscription } = useUser()
    const nowUnix = Math.round(new Date().getTime() / 1000)
    const trialEnd = new Date((activeSubscription?.trial_end ?? nowUnix) * 1000)

    const handleSubscribe = (plan: BillingPlan) => {
        setSelectedPlan(plan)
    }

    return (
        <div className="mb-40">
            <IntervalToggle interval={interval} setInterval={setInterval} />

            <div className="flex justify-center flex-fill gap-x-12">
                <PlanCard plan={StandardPlanV1} interval={interval} onSubscribe={handleSubscribe} />
                <PlanCard plan={PremiumPlanV1} interval={interval} onSubscribe={handleSubscribe} />
            </div>

            <ConfirmationDrawer
                trial_end_date={trialEnd}
                plan={selectedPlan}
                setPlan={setSelectedPlan}
                trial_days={14}
                interval={interval}
            />
        </div>
    )
}

interface IntervalToggleProps {
    interval: Interval
    setInterval: (interval: Interval) => void
}

export const IntervalToggle = ({ interval, setInterval }: IntervalToggleProps) => {
    return (
        <div className="flex items-center justify-center gap-2 mb-8 mt-12">
            <div
                className={classNames('font-medium', {
                    'text-gray-400': interval == Interval.Yearly,
                })}
            >
                Billed Monthly
            </div>
            <Switch
                large
                checked={interval === Interval.Yearly}
                onChange={() =>
                    setInterval(interval === Interval.Yearly ? Interval.Monthly : Interval.Yearly)
                }
            />
            <div
                className={classNames('font-medium', {
                    'text-gray-400': interval == Interval.Monthly,
                })}
            >
                Billed Yearly
            </div>
        </div>
    )
}
